import type { LibraTicket } from 'features/libra/ticket/libraTicketsApi'
import type { FC } from 'react'

import type { LifecycleStage } from './lifecycleTypes'
import type { LifecycleAction } from './TicketLifecycleContext'

// ---------------------------------------------------------------------------
// Shared props contract for all lifecycle action layout components
// ---------------------------------------------------------------------------

export interface LifecycleActionComponentProps {
  actions: LifecycleAction[]
  ticket: LibraTicket
  currentStage: LifecycleStage
  isTerminal: boolean
}

// ---------------------------------------------------------------------------
// Component registry
// ---------------------------------------------------------------------------

type ActionLayoutComponent = FC<LifecycleActionComponentProps>

const actionComponentRegistry: Record<string, ActionLayoutComponent> = {}

export function registerActionComponent(
  key: string,
  component: ActionLayoutComponent
): void {
  actionComponentRegistry[key] = component
}

export function getActionLayoutComponent(
  key: string
): ActionLayoutComponent | undefined {
  return actionComponentRegistry[key]
}
